import { useTheme } from '@mui/material';
import { formatCurrency } from '../../../utils/formatUtils';

const MoneyDisplay = ({ amount, type, noSign = false }: { plainText?: boolean, amount: number, type?: 'credit' | 'debit' | 'history' | undefined, noSign?: boolean }) => {
  const theme = useTheme();

  const formattedAmount = `${noSign ? '' : type === 'credit' || amount > 0 ? '+' : '-'}${formatCurrency(amount || 0)}`
    .replace('--', '-')
    .replace('++', '+');

  if (!type) return <>{formatCurrency(amount || 0)}</>;

  return (
    <span style={{ color: type === 'history' && amount > 0 ? theme.palette.green[500] : undefined }}>
      {formattedAmount}
    </span>
  );
};

export default MoneyDisplay;